import { render, staticRenderFns } from "./CompilationEmptyPlaceholder.vue?vue&type=template&id=213552a0"
import script from "./CompilationEmptyPlaceholder.vue?vue&type=script&lang=js"
export * from "./CompilationEmptyPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./CompilationEmptyPlaceholder.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports